/* eslint-disable consistent-return */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import { useQuery } from '@apollo/client';
// import { useRouter } from 'next/router';
import Grid from '@mui/material/Grid';
import { Divider, Box, Fab } from '@mui/material';
import RoomIcon from '@mui/icons-material/Room';
import LanguageIcon from '@mui/icons-material/Language';
import PublicIcon from '@mui/icons-material/Public';
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import Container from '@material-ui/core/Container';
import Skeleton from '@mui/lab/Skeleton';
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
// import LocationOnIcon from '@material-ui/icons/LocationOn';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import moment from 'moment';
import Typography from '@atoms/Typography';
import Spacer from '@atoms/Spacer';
import ImageLightbox from '@molecules/ImageLightbox';
import OpportunityFee from '@molecules/OpportunityFee';
import Link from '@atoms/Link';
import { dateTimeVisibilityHandler } from '@app/helpers/dateVisibilityHandler';
import { capitalize, redirectToRoute } from '@app/helpers';
import VideoItem from '@molecules/VideoLink/VideoItem';
import { OPP_STATUS_ENUM } from '@app/constants';

import {
  FacebookShareButton,
  InstapaperShareButton,
  TwitterShareButton,
  LinkedinShareButton,
} from 'react-share';
import VideoSlider from '../../common/VideoSlider';
import Card from '../../../atoms/Card';

import {
  OpportunityMeta,
  ActionsContainer,
  ChipsContainer,
  BodyText,
  SectionDivider,
  OrgAvatar,
  LogoContainer,
  StyledChip,
  DedaLine,
  ShareBox,
} from './style';

import { useTranslation, i18n } from '../../../../config/i18n';

const getImagesArray = (images, attr) => images.map((image) => image[attr]);

const ViewOpportunity = ({ slug, opportunity, loading }) => {
  const { t } = useTranslation('wizard', 'dashboard', 'common', 'organisations');

  const applyPageHandler = () => {
    redirectToRoute({}, 'form_viewer', { params: { slug } });
  };

  const [isMobile, setIsMobile] = useState(false)
  const [isAvailableFees, setIsAvailableFees] = useState(true);

  React.useEffect(() => {
    if (opportunity && opportunity.payment_details && opportunity.slots_status) {
      opportunity.payment_details.forEach((payment) => {
        opportunity.slots_status.forEach((slot) => {
          if (payment.code === slot.code) {
            if (payment.slots <= slot.slots) {
              setIsAvailableFees(false);
            } else {
              setIsAvailableFees(true);
              return true;
            }
          } else {
            setIsAvailableFees(true);
          }
        })
      })
    }
  }, [])

  const userCanApply = () => {
    let isAvailable = opportunity && opportunity.form && !opportunity.form.is_skipped;

    if (opportunity.deadline_date) {
      isAvailable = isAvailable && moment(opportunity.deadline_date).diff(moment()) > 0;
    } else if (!opportunity.deadline_date && opportunity.start_date) {
      isAvailable = isAvailable && moment(opportunity.start_date).diff(moment()) > 0;
    }

    // return userInfo && isAvailable;

    return isAvailable;
  };

  React.useEffect(() => {
    if (window.innerWidth < 600) {
      setIsMobile(true)
    }
  }, [])

  const formatExperienceLevel = (experienceLevel) => {
    if (Array.isArray(experienceLevel)) {
      return experienceLevel.map(level => t(level.toLowerCase())).join(', ');
    } if (typeof experienceLevel === 'string') {
      return t(experienceLevel.toLowerCase());
    }
    return '';
  }

  return (
    <>
      {/* {opportunity && <DefaultSeo {...PAGE_SEO} />} */}

      <Card>
        {/* <ImageContainer item sm={12} md={4} lg={4} xs={12}>
              {loading ? (
                <Skeleton animation="wave" variant="rect" height="100%" width="100%" />
              ) : (
                <CoverImage src={opportunity && opportunity.logo.path} />
              )}
            </ImageContainer> */}

        <BodyText>
          <Spacer height="3rem" />
          {opportunity.start_date && dateTimeVisibilityHandler(opportunity, 'h6', 'secondary')}

          {loading ? (
            <Box width="40%" marginBottom="1.4rem">
              <Skeleton animation="wave" variant="rect" height={40} width="100%" />
            </Box>
          ) : (
            <Typography variant="h2" gutterBottom>
              {opportunity.title}
            </Typography>
          )}

          <LogoContainer>
            <Link href="organisation_view" params={{ slug: opportunity.organisation.slug }}>
              <OrgAvatar width="100px" src={opportunity.organisation.logo.thumb} />
            </Link>
            <Link sx={{ textDecoration: 'none' }} href="organisation_view" params={{ slug: opportunity.organisation.slug }}>
              <Typography variant="body1">{opportunity.organisation.name}</Typography>
            </Link>
          </LogoContainer>

          <Grid container>
            <Grid item xs={12} sm={12}>
              {loading ? (
                <>
                  {Array.from(new Array(3)).map(() => (
                    <Box marginTop="0.5rem" marginBottom="0.5rem">
                      <Skeleton animation="wave" variant="rect" height={27} width="50%" />
                    </Box>
                  ))}
                </>
              ) : (
                <Box>
                  {opportunity.types && opportunity.types.length > 0 && (
                    <OpportunityMeta variant="body1">
                      <LibraryMusicIcon />
                      {opportunity.types.map((type, i) =>
                        i === 0 ? type.name : `, ${type.name}`
                      )}
                    </OpportunityMeta>
                  )}

                  {opportunity.is_virtual || opportunity.is_worldwide ? (
                    <>
                      {opportunity.is_virtual && (<OpportunityMeta variant="body1">
                        <LanguageIcon />
                        {t('common:virtual_opportunity')}
                      </OpportunityMeta>)}
                      {opportunity.is_worldwide && (<OpportunityMeta variant="body1">
                        <PublicIcon />
                        {t('common:worldwide_opportunity')}
                      </OpportunityMeta>)}
                    </>
                  ) : (
                    opportunity.location && (
                      <OpportunityMeta variant="body1">
                        <RoomIcon />
                        {opportunity.location.formatted_address}
                      </OpportunityMeta>
                    )
                  )}

                  <ActionsContainer>
                    <Divider />
                    {userCanApply() &&  (opportunity.opp_status === OPP_STATUS_ENUM.PUBLISHED || opportunity.opp_status === OPP_STATUS_ENUM.ACTIVE) && (
                      <>
                        <Fab
                          className="applyButton"
                          variant="extended"
                          fullWidth
                          startIcon={<AssignmentTurnedInIcon />}
                          color="primary"
                          size="large"
                          disabled={!isAvailableFees}
                          onClick={applyPageHandler}
                          style={{ padding: "1.75rem 1.5rem", borderRadius: "30px" }}
                        >
                          <AssignmentTurnedInOutlinedIcon />
                          <Spacer width="0.5rem" />
                          {isAvailableFees ? t('common:apply') : 'Sold Out'}
                        </Fab>
                        <Spacer width='1rem' height='1rem' />
                        {/* {!isAvailableFees && <Typography variant='body1' color='secondary'>No fees available.</Typography>} */}
                      </>
                    )}
                    {isMobile && <Divider />}
                  </ActionsContainer>
                  {opportunity.deadline_date && (
                    <DedaLine variant="body1">
                      <AccessAlarmsIcon />
                      {`${t('common:deadline')}: ${moment(opportunity.deadline_date).format(
                        `${opportunity.time_visibility?.deadline_time
                          ? 'DD MMM YYYY  HH:mm'
                          : 'D MMM YYYY'
                        }`
                      )}`}
                    </DedaLine>
                  )}
                </Box>
              )}
            </Grid>
          </Grid>
          {/* </CardContent> */}
        </BodyText>

        {loading ? (
          <>
            {Array.from(new Array(10)).map(() => (
              <Box width="100%" marginBottom="1.5rem">
                <Skeleton animation="wave" variant="rect" height={30} width="100%" />
              </Box>
            ))}
          </>
        ) : (
          <>
            <BodyText>
              <Typography variant="h5" weight="700">
                {t('common:description')}
              </Typography>
              <Spacer height="1rem" />
              <Typography variant="body1" style={{ wordBreak: 'break-word', whiteSpace: 'break-spaces' }}>
                {opportunity.description}
              </Typography>

              <ShareBox>
                <Typography variant="overline" gutterBottom color="secondary">
                  {t('opportunity:share')}
                </Typography>
                <InstapaperShareButton
                  url={`https://mubazar.com/${i18n.language}/opportunity/${slug}`}
                >
                  <InstagramIcon color="primary" />
                </InstapaperShareButton>
                <TwitterShareButton
                  url={`https://mubazar.com/${i18n.language}/opportunity/${slug}`}
                >
                  <TwitterIcon color="primary" />
                </TwitterShareButton>

                <FacebookShareButton
                  url={`https://mubazar.com/${i18n.language}/opportunity/${slug}`}
                >
                  {' '}
                  <FacebookIcon color="primary" />
                </FacebookShareButton>
                <LinkedinShareButton
                  url={`https://mubazar.com/${i18n.language}/opportunity/${slug}`}
                >
                  <LinkedInIcon color="primary" />
                </LinkedinShareButton>
              </ShareBox>
              <SectionDivider />
            </BodyText>
            {/* <Grid container direction="row" justify="space-between">
                      <OpportunityMeta variant="body1" weight="600">
                        {t('common:visibility')}
                      </OpportunityMeta>
                      <OpportunityMeta variant="body1">
                        {opportunity.is_private ? (
                          <LockOutlinedIcon fontSize="small" />
                        ) : (
                          <LockOpenOutlinedIcon fontSize="small" />
                        )}
                        {opportunity.is_private ? t('common:private') : t('common:public')}
                      </OpportunityMeta>
                    </Grid> */}
            {/* <Divider /> */}
            <BodyText>
              <Typography variant="overline" weight="600" color="primary">
                {t('target')}
              </Typography>
              <Typography variant="h4">{t(opportunity.target.toLowerCase())}</Typography>

              <Spacer height="1rem" />

              <Typography variant="overline" weight="600" color="primary">
                {t('age_limit')}
              </Typography>
              <Typography variant="h4">
                {opportunity.max_age
                  ? `${opportunity.min_age || 0} - ${opportunity.max_age}`
                  : t('common:all_ages')}
              </Typography>

              <Spacer height="1rem" />

              {(opportunity.experience_level || opportunity.experience_level?.length > 0) && (
                <>
                  <Typography variant="overline" weight="600" color="primary">
                    {t('experience')}
                  </Typography>
                  <Typography variant="h4">
                    {formatExperienceLevel(opportunity.experience_level)}
                  </Typography>
                </>
              )}
            </BodyText>
            <Spacer height="1rem" />

            {opportunity.target_countries.length > 0 && (
              <BodyText>
                <OpportunityMeta variant="h5" weight="700" gutterBottom>
                  {t('wizard:open_to_following_countries')}
                </OpportunityMeta>

                <ChipsContainer>
                  {opportunity.target_countries.map((country) => (
                    <StyledChip key={country.id} variant="outlined" label={country.name} />
                  ))}
                </ChipsContainer>

                <Spacer height="1rem" />
              </BodyText>
            )}
            {opportunity.genres.length > 0 && (
              <BodyText>
                <OpportunityMeta variant="h5" weight="700" gutterBottom>
                  {t('common:genres')}
                </OpportunityMeta>

                <ChipsContainer>
                  {opportunity.genres.map((genre) => (
                    <StyledChip
                      key={genre.id}
                      variant="outlined"
                      label={genre.name === 'all' ? t('common:all') : capitalize(genre.name)}
                    />
                  ))}
                </ChipsContainer>

                <Spacer height="1rem" />
              </BodyText>
            )}

            {opportunity.instruments.length > 0 && (
              <BodyText>
                <OpportunityMeta variant="h5" weight="700" gutterBottom>
                  {t('common:instruments')}
                </OpportunityMeta>

                <ChipsContainer>
                  {opportunity.instruments.map((instrument) => (
                    <StyledChip
                      key={instrument.id}
                      variant="outlined"
                      label={
                        instrument.name === 'all' ? t('common:all') : capitalize(instrument.name)
                      }
                    />
                  ))}
                </ChipsContainer>
                <Spacer height="1rem" />
              </BodyText>
            )}

            {opportunity.languages.length > 0 && (
              <BodyText>
                <OpportunityMeta variant="h5" weight="700" gutterBottom>
                  {t('common:languages')}
                </OpportunityMeta>
                <ChipsContainer>
                  {opportunity.languages.map((language) => (
                    <StyledChip
                      key={language.id}
                      variant="outlined"
                      label={language.name === 'all' ? t('common:all') : capitalize(language.name)}
                    />
                  ))}
                </ChipsContainer>

                <Spacer height="1rem" />
              </BodyText>
            )}

            <Spacer height="1rem" />
            <BodyText>
              {opportunity.payment_details && opportunity.payment_details.length > 0 && (
                <Grid item xs={12}>
                  <OpportunityMeta variant="h5" weight="700" color="secondary" gutterBottom>
                    {t('wizard:fee_type.opportunity_cost')}
                  </OpportunityMeta>
                </Grid>
              )}

              {/* <Grid item xs={12}>
                <Typography variant="body1" as="pre">
                  {getOpportunityPaymentType(opportunity) === OPPORTUNITY_PAYMENT.PAID_INTERNAL &&
                    t('application_fee.paid_internal')}

                  {getOpportunityPaymentType(opportunity) === OPPORTUNITY_PAYMENT.PAID_EXTERNAL &&
                    t('application_fee.paid_external')}

                  {getOpportunityPaymentType(opportunity) === OPPORTUNITY_PAYMENT.FREE &&
                    t('application_fee.free')}
                </Typography>
                <Spacer height="1rem" />
                  </Grid> */}
              {opportunity.payment_details &&
                opportunity.payment_details.length > 0 &&
                opportunity.payment_details.map((fee) => <OpportunityFee {...fee} />)}
            </BodyText>
            {opportunity.video_links &&
              opportunity.video_links.length > 0 &&
              opportunity.video_links[0] !== null && (
                <>
                  <BodyText>
                    <OpportunityMeta variant="h5" weight="700" gutterBottom>
                      {t('common:videos')}
                    </OpportunityMeta>
                  </BodyText>
                  {opportunity.video_links.length === 1 ? (
                    <VideoItem width={350} value={opportunity.video_links[0]} />
                  ) : (
                    <VideoSlider videos={opportunity.video_links} />
                  )}
                </>
              )}
            <Spacer height="2rem" />
            <BodyText>
              {opportunity.gallery.length > 0 && (
                <>
                  <OpportunityMeta variant="h5" weight="700" gutterBottom>
                    {t('Images')}
                  </OpportunityMeta>
                  <ImageLightbox
                    // thmubsSize="160px"
                    images={getImagesArray(opportunity.gallery, 'path')}
                  />
                </>
              )}
            </BodyText>
            <Spacer height="2rem" />
          </>
        )}

        {/*  {loading ? (
          <>
            {Array.from(new Array(3)).map(() => (
              <Box width="100%" marginBottom="1rem">
                <Skeleton animation="wave" variant="rect" height={20} width="100%" />
              </Box>
            ))}
          </>
        ) : (
          <></>
        )} */}
      </Card>
    </>
  );
};

ViewOpportunity.propTypes = {
  slug: PropTypes.string.isRequired,
  opportunity: PropTypes.object,
  loading: PropTypes.bool.isRequired,
};

ViewOpportunity.defaultProps = {
  opportunity: null,
};

export default ViewOpportunity;
